import React, { useEffect } from "react";

export default function Datenschutz() {
  useEffect(() => {
    document.title = "Datenschutzerklärung | Rechtsanwalt Sindros";
  }, []);

  return (
    <div>
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <h1
            className="text-4xl font-bold mb-4"
            style={{
              color: "#1B3A5C",
              fontFamily: "'Source Serif 4', serif",
            }}
          >
            Datenschutzerklärung
          </h1>
          <p className="text-sm mb-12" style={{ color: "#777777" }}>
            Stand: 15. Februar 2026
          </p>

          <div className="space-y-10" style={{ color: "#555555" }}>
            {/* 1. Verantwortlicher */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                1. Verantwortlicher
              </h2>
              <p className="text-base leading-relaxed">
                Rechtsanwalt Sindros
                <br />
                c/o THE PUMA GROUP
                <br />
                Arxaiologikou Mouseiou 17
                <br />
                54640 Thessaloniki, Griechenland
                <br />
                E-Mail: info@fairebewertungen.de
                <br />
                Telefon: 0178-4660549
              </p>
            </div>

            {/* 2. Allgemeines */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                2. Allgemeines zur Datenverarbeitung
              </h2>
              <p className="text-base leading-relaxed">
                Wir verarbeiten personenbezogene Daten grundsätzlich nur, soweit
                dies zur Bereitstellung unserer Website und Dienstleistungen
                erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur mit
                Einwilligung des Nutzers oder wenn die Verarbeitung gesetzlich
                gestattet ist.
              </p>
            </div>

            {/* 3. Rechtsgrundlagen */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                3. Rechtsgrundlagen der Verarbeitung
              </h2>
              <ul className="space-y-2 ml-6">
                <li className="text-base leading-relaxed relative pl-5">
                  <span
                    className="absolute left-0 top-[10px] w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: "#2E75B6" }}
                  />
                  Art. 6 Abs. 1 lit. a DSGVO – Einwilligung
                </li>
                <li className="text-base leading-relaxed relative pl-5">
                  <span
                    className="absolute left-0 top-[10px] w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: "#2E75B6" }}
                  />
                  Art. 6 Abs. 1 lit. b DSGVO – Vertragserfüllung
                </li>
                <li className="text-base leading-relaxed relative pl-5">
                  <span
                    className="absolute left-0 top-[10px] w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: "#2E75B6" }}
                  />
                  Art. 6 Abs. 1 lit. c DSGVO – Rechtliche Verpflichtung
                </li>
                <li className="text-base leading-relaxed relative pl-5">
                  <span
                    className="absolute left-0 top-[10px] w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: "#2E75B6" }}
                  />
                  Art. 6 Abs. 1 lit. f DSGVO – Berechtigte Interessen
                </li>
              </ul>
            </div>

            {/* 4. Logfiles */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                4. Bereitstellung der Website und Logfiles
              </h2>
              <p className="text-base leading-relaxed">
                Bei jedem Aufruf erfasst unser System automatisch: Browsertyp/-version,
                Betriebssystem, Referrer URL, IP-Adresse (anonymisiert), Uhrzeit
                der Anfrage, übertragene Datenmenge. Rechtsgrundlage: Art. 6 Abs.
                1 lit. f DSGVO. Löschung nach 30 Tagen.
              </p>
            </div>

            {/* 5. Kontaktaufnahme */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                5. Kontaktaufnahme
              </h2>
              <p className="text-base leading-relaxed">
                Bei Kontaktaufnahme per E-Mail oder Formular verarbeiten wir:
                Name, E-Mail, Telefonnummer, Unternehmensdaten,
                Nachrichteninhalt. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
              </p>
            </div>

            {/* 6. Hosting */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                6. Hosting
              </h2>
              <p className="text-base leading-relaxed">
                Unsere Website wird gehostet bei Emergent. Mit dem
                Hosting-Anbieter wurde ein Auftragsverarbeitungsvertrag (AVV)
                gemäß Art. 28 DSGVO geschlossen.
              </p>
            </div>

            {/* 7. SSL */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                7. SSL-/TLS-Verschlüsselung
              </h2>
              <p className="text-base leading-relaxed">
                Diese Website nutzt SSL- bzw. TLS-Verschlüsselung. Erkennbar an
                „https://“ in der Adresszeile.
              </p>
            </div>

            {/* 8. Cookies */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                8. Cookies
              </h2>
              <p className="text-base leading-relaxed">
                Unsere Website verwendet technisch notwendige Cookies (Art. 6
                Abs. 1 lit. f DSGVO). Andere Cookies werden nur mit Ihrer
                Einwilligung gesetzt.
              </p>
            </div>

            {/* 9. Analyse-Tools */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                9. Analyse-Tools und Tracking
              </h2>
              <p className="text-base leading-relaxed">
                Wir verwenden derzeit keine Analyse- oder Tracking-Tools, die
                personenbezogene Daten verarbeiten.
              </p>
            </div>

            {/* 10. Rechte */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                10. Rechte der Betroffenen
              </h2>
              <p className="text-base leading-relaxed">
                Sie haben folgende Rechte: Auskunft (Art. 15 DSGVO), Berichtigung
                (Art. 16), Löschung (Art. 17), Einschränkung (Art. 18),
                Datenübertragbarkeit (Art. 20), Widerspruch (Art. 21), Widerruf
                der Einwilligung (Art. 7 Abs. 3).
              </p>
            </div>

            {/* 11. Beschwerderecht */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                11. Beschwerderecht
              </h2>
              <p className="text-base leading-relaxed">
                Zuständige Aufsichtsbehörde: Hellenic Data Protection Authority
                (HDPA), Kifissias 1-3, 115 23 Athens, Griechenland. Website:{" "}
                <a
                  href="https://www.dpa.gr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                  style={{ color: "#2E75B6" }}
                >
                  www.dpa.gr
                </a>
              </p>
              <p className="text-base leading-relaxed mt-4">
                In Deutschland können Sie sich auch an die zuständige
                Landesaufsichtsbehörde wenden.
              </p>
            </div>

            {/* 12. Änderung */}
            <div>
              <h2
                className="text-xl font-bold mb-4"
                style={{ color: "#1B3A5C" }}
              >
                12. Änderung der Datenschutzerklärung
              </h2>
              <p className="text-base leading-relaxed">
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen,
                damit sie stets den aktuellen rechtlichen Anforderungen
                entspricht.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
